import { useCallback, useContext, useEffect, useState } from "react"
import { SamplesContext } from "../../../context/samplesContext"
import { useNavigate } from "react-router-dom"
import { buildPathWithSampleId, PATH_INFO } from "../../utils/helper"
import { BlackButton } from "../../../components/buttons/BlackButton"
import paperIcon from '../../../assets/images/icons/paper-white.svg'
import importIcon from '../../../assets/images/icons/import.svg'
import downloadIcon from '../../../assets/images/icons/download.svg'
import ecImageDownloadIcon from '../../../assets/images/icons/t-shirt-down-arrow.svg'
import pastMeasurementIcon from '../../../assets/images/icons/paper-plus.svg'
import { DESKTOP_XMD_BREAKPOINT_PX, MEDIA_QUERY_MAX_DESKTOP_XMD } from "../../../constants/breakpoints" // Tailwindのdesktop-xmdと同期させるためconstantsで管理している値を使用
import { UserContext } from "../../../context/userContext"
import { MeasurementReportDownloadErrorModal } from "../utils/MeasurementReportDownloadErrorModal"
import { downloadMeasurementReport } from "../utils/measurementReportDownload"

export function ActionButtonsPanel() {
  const { rowSample, canvasImage } = useContext(SamplesContext)
  const { isAuth, isGuest } = useContext(UserContext)
  const canEdit = Boolean(isAuth) && !isGuest

  const [isSmall, setIsSmall] = useState(false)
  const [downloadError, setDownloadError] = useState("")
  const [isDownloadErrorModalOpen, setIsDownloadErrorModalOpen] = useState(false)

  const navigate = useNavigate()
  const closeDownloadErrorModal = useCallback(() => {
    setIsDownloadErrorModalOpen(false)
    setDownloadError("")
  }, [])

  const downloadPdf = useCallback(async () => {
    const errorMessage = await downloadMeasurementReport({
      sampleId: rowSample.id,
      sampleUrl: rowSample.url ?? undefined,
      sampleImage: canvasImage,
      navigate
    })
    if (errorMessage) {
      setDownloadError(errorMessage)
      setIsDownloadErrorModalOpen(true)
    }
  }, [navigate, rowSample, canvasImage])

  // desktop-xmd未満(タブレットレイアウト時)にボタンの文言を変更(ダウンロード → Download)
  useEffect(() => {
    const media = window.matchMedia(MEDIA_QUERY_MAX_DESKTOP_XMD) // desktop-xmd未満（tailwind.config.jsの値と同じ）
    const listener = () => setIsSmall(media.matches)

    listener()
    media.addEventListener('change', listener)

    return () => media.removeEventListener('change', listener)
  }, [])

  return (
    <div className="text-white space-y-[5px] desktop-xmd:mt-[25px] desktop-xmd:space-y-[10px]">
      <div className="flex space-x-[5px] desktop-xmd:space-x-[9px]">
        <BlackButton
          label="過去の採寸を表示"
          subLabelParts={["表示中の採寸の", "過去の採寸表を表示"]}
          onClickHandle={() => navigate(buildPathWithSampleId(PATH_INFO.PAST_MEASUREMENTS.PATH, rowSample.id))}
          iconSrc={paperIcon}
          iconHeight="21"
          iconWidth="21"
          canEdit={canEdit}
        />
        <BlackButton
          label="仕様書取り込み"
          subLabelParts={["指示寸法を入力", "(寸法を比較する)"]}
          subLabelBreakpointPx={DESKTOP_XMD_BREAKPOINT_PX}
          onClickHandle={() => navigate(buildPathWithSampleId(PATH_INFO.SPECIFICATION_INPORT.PATH, rowSample.id))}
          iconSrc={importIcon}
          iconHeight="21"
          iconWidth="21"
          canEdit={canEdit}
        />
      </div>
      <div className="flex space-x-[5px] desktop-xmd:space-x-[9px]">
        <BlackButton
          label={`採寸表${isSmall ? 'Download' : 'ダウンロード'}`}
          subLabelParts={["表示中の採寸表をpdfで", "ダウンロード"]}
          subLabelBreakpointPx={DESKTOP_XMD_BREAKPOINT_PX}
          onClickHandle={downloadPdf}
          iconSrc={downloadIcon}
          iconHeight="21"
          iconWidth="21"
          canEdit={canEdit}
        />
        <BlackButton
          label={`EC画像${isSmall ? 'Download' : 'ダウンロード'}`}
          subLabelParts={["撮影したEC画像のみを", "ダウンロード"]}
          subLabelBreakpointPx={DESKTOP_XMD_BREAKPOINT_PX}
          onClickHandle={() => { navigate(buildPathWithSampleId(PATH_INFO.EC_PHOTO.PATH, rowSample.id)) }}
          iconSrc={ecImageDownloadIcon}
          iconHeight="21"
          iconWidth="21"
          canEdit={canEdit}
        />
      </div>
      <BlackButton
        label="過去の採寸表をダウンロード"
        subLabelParts={["過去に採寸した採寸表をダウンロード"]}
        onClickHandle={() => { navigate(buildPathWithSampleId(PATH_INFO.SPECIFICATION_DOWNLOAD.PATH, rowSample.id)) }}
        iconSrc={pastMeasurementIcon}
        iconHeight="21"
        iconWidth="21"
        canEdit={canEdit}
      />
      <MeasurementReportDownloadErrorModal
        isOpen={isDownloadErrorModalOpen && Boolean(downloadError)}
        onClose={closeDownloadErrorModal}
        message={downloadError}
      />
    </div>
  )
}
